import PropTypes from 'prop-types';
import React from 'react';
import { contentfulViews } from '@glowforge/ui-common';
import GlobalFooter from 'app/common/components/global-footer';

import '@glowforge/ui-common/stylesheets/base.less';
import '@glowforge/ui-common/components/navigation/top-nav.less';

import BasicApp from './basic-app';

import './marketing-app.less';

const { Page } = contentfulViews;

const MarketingApp = props => (
  <BasicApp {...props} className='MarketingApp' includeBuyButton>
    <Page {...props} />
    <GlobalFooter {...props} />
  </BasicApp>
);

export default MarketingApp;



// WEBPACK FOOTER //
// ./app/components/root-apps/marketing-app.jsx